import i18nRU from '@emoji-mart/data/i18n/ru.json'
import data from '@emoji-mart/data/sets/1/native.json'
import { useAtom } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { languageAtom } from '@root/shared/localization'
import { currentThemeAtom } from '@root/shared/theme'

import type EmojiMart from 'emoji-mart'
const Picker_ = React.lazy(() => import('@emoji-mart/react'))

type Props = {
  [K in keyof typeof EmojiMart.Picker.Props]?: (typeof EmojiMart.Picker.Props)[K]['value']
}

export const EmojiPicker = (props: Props) => {
  const [lang] = useAtom(languageAtom)
  const [currentTheme] = useAtom(currentThemeAtom)
  return (
    <React.Suspense fallback={<></>}>
      <Root>
        <Picker_
          data={data}
          i18n={lang === 'ru' ? i18nRU : undefined}
          locale={lang}
          theme={currentTheme.appearance}
          {...props}
        />
      </Root>
    </React.Suspense>
  )
}
const Root = styled.div`
  em-emoji-picker {
    --rgb-accent: var(--primary-9-rgb);
  }
`
